import React, { useContext } from "react";
import Panel from "./Panel";

import { useSelector, useDispatch } from "react-redux";
import { map_coins, map_coin_to_name } from "store/constant";
import { map_balance_to_coin } from "store/constant";
// import useKrakenOHLC from "hooks/useKrakenOHLC";
import { Button, IconButton } from "@material-ui/core";
import DailyHiLo from "../../components/DailyHiLo";
import colors from "assets/scss/_themes-vars.module.scss";
import ToolTipHelper from 'ui-component/ToolTipHelper';
import {tooltips} from 'constants/tooltips';

// material-ui
import { useTheme } from "@material-ui/styles";
import { Grid, Box, Typography, Tab, Tabs } from "@material-ui/core";

// third party
import ApexCharts from "apexcharts";
import TakyonLightweightChart from "./Chart";

// project imports
import SubCard from "ui-component/cards/SubCard";

import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import CoinContext from "contexts/CoinContext";
import TradesCoin from "../../Trades/TradesCoin";
import OrdersCoin from "./OrdersCoin.js";

import { 
    setSecondInterval, 
    FETCH_MLFORECAST_REQUEST,
    FETCH_MLFORECAST_REQUEST_SECOND,
    FETCH_MLFORECAST_REQUEST_THIRD,
    FETCH_MLFORECAST_REQUEST_FIRST,
} from "store/actions";

// ===========================|| DASHBOARD ANALYTICS - MARKET SHARE AREA CHART CARD ||=========================== //

const SecondChartCard = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const cornsilk =
    theme.palette.mode === "dark"
      ? colors.cornsilkLightTakyon
      : colors.cornsilkDarkTakyon;
  const whiteTakyon =
    theme.palette.mode === "dark"
      ? colors.whiteLightTakyon
      : colors.whiteDarkTakyon;
  const green =
    theme.palette.mode === "dark"
      ? colors.successLightTakyon
      : colors.successDarkTakyon;
  const red =
    theme.palette.mode === "dark"
      ? colors.errorLightTakyon
      : colors.errorDarkTakyon;

  const { coin } = useContext(CoinContext);
  const ohlcIntervalSecond = useSelector((state) => state.chart.ohlcIntervalSecond);
  const setInterval = (interval) => dispatch(setSecondInterval(interval));

  const coin_style = map_coins.get(coin);
  // const coin_name = map_coin_to_name.get(coin) ? map_coin_to_name.get(coin) : coin;
  const coin_name = useSelector((state) => {
    const row = state.coins.kraken_asset_pairs && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin) || undefined;
    if ( row === undefined)
    {
        return coin;
    }
    const coin_name = row.marketcap ?  row.marketcap.Name : (row.base_currency ? row.base_currency : (row.base ? row.base : row.wsname));
    return coin_name;
  });

  const [tabsValue, setTabsValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabsValue(newValue);
  };

    const handlePredict = () => {
        console.log('SECOND ------ HANDLE_PREDICT ' + coin);
        {
            const postdata = { "query": {"height": 25, "type": 2, "symbol": coin + "-15"}};
            console.log(JSON.stringify(postdata));
            dispatch( {type: FETCH_MLFORECAST_REQUEST_SECOND, payload: postdata});
        }
        {
            const postdata = { "query": {"height": 10, "type": 2, "symbol": coin + "-30"}};
            console.log(JSON.stringify(postdata));
            dispatch( {type: FETCH_MLFORECAST_REQUEST_THIRD, payload: postdata});
        }
        {
            const postdata = { "query": {"height": 35, "type": 2, "symbol": coin + "-5"}};
            console.log(JSON.stringify(postdata));
            dispatch( {type: FETCH_MLFORECAST_REQUEST, payload: postdata});
        }
        {
            const postdata = { "query": {"height": 40, "type": 2, "symbol": coin + "-1"}};
            console.log(JSON.stringify(postdata));
            dispatch( {type: FETCH_MLFORECAST_REQUEST_FIRST, payload: postdata});
        }
    };


  const intervals = [
    { interval: "1", title: "1m" },
    { interval: "5", title: "5m" },
    { interval: "15", title: "15m" },
    { interval: "30", title: "30m" },
  ];

  const ltp = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(coin)               &&
                 state.coins.kraken_asset_pairs.get(coin).ltp
                 )
                 || undefined);
  });

  const daily = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(coin)               &&
                 state.coins.kraken_asset_pairs.get(coin).daily
                 )
                 || undefined);
  });

  const daily_hi = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(coin)               &&
                 state.coins.kraken_asset_pairs.get(coin).daily_hi
                 )
                 || 0.0);
  });
  const daily_lo = useSelector((state) => {
     return (
                (state.coins.kraken_asset_pairs_loaded                  &&
                 state.coins.kraken_asset_pairs.get(coin)               &&
                 state.coins.kraken_asset_pairs.get(coin).daily_lo
                 )
                 || 0.0);
  });
  const daily_percent = useSelector((state) => {
     return (
                (
                 state.coins.kraken_asset_pairs.get(coin)               &&
                 state.coins.kraken_asset_pairs.get(coin).hilo_percent
                 )
                 || 0.0);
  });

  return (
        <SubCard >
          <Grid container spacing={1} padding={1} alignItems="space-between">


            <Grid item xs={3.5}  >
              <Panel ltp={ltp} daily_hi={daily_hi} daily_lo={daily_lo} daily_percent={daily_percent} />


            </Grid>
            <Grid item xs={0.5}>
              <font style={{ spacing: "10px", "font-size": "0.9rem" }} class={coin_style} >
                  {coin_name}{" "}
                </font>
            </Grid>
            <Grid item xs={3} align="center" justifyContent="right" alignItems="right">
                {intervals.map((intervalItem) => (
                  <IconButton
                    key={intervalItem.interval}
                    sx={{
                      color:
                            (intervalItem.interval === ohlcIntervalSecond && ohlcIntervalSecond === "1")
                                ? 'white'
                                : ( (intervalItem.interval === ohlcIntervalSecond && ohlcIntervalSecond === "5")
                                    ? 'yellow'
                                    : ( (intervalItem.interval === ohlcIntervalSecond && ohlcIntervalSecond === "15")
                                        ? '#FFA500'
                                        : ((intervalItem.interval === ohlcIntervalSecond && ohlcIntervalSecond === "30")
                                            ? 'red'
                                            : 'darkgray'
                                          )
                                      )
                                  ),
                    }}
                    size="small"
                    onClick={() => setInterval(intervalItem.interval)}
                  >
                    {intervalItem.title}
                  </IconButton>
                ))}
            </Grid>
            <Grid item xs={1.0}  align="center" justifyContent="center" alignItems="center" >
                  <Button
                    key={'second'}
                    sx={{ bgcolor: "white", color: "black" }}
                    size="small"
                    onClick={handlePredict}
                  >
                    {"Predict"}
                  </Button>
            </Grid>
            <Grid item xs={2.5}  >
                <DailyHiLo dh={daily_hi} dl={daily_lo} ltp={ltp} avg_px={0} />
            </Grid>
            <Grid item xs={0.5}  >
                <ToolTipHelper  hover={tooltips.interval.hover} modal={tooltips.interval.modal} />
            </Grid>

          </Grid>
          <TakyonLightweightChart chart_index={0} current_coin={coin}/>
        </SubCard>
  );
};
export default SecondChartCard;
